import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deviceData-E",
  "use": "deviceData-E-usage",
  "viewBox": "0 0 7 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 11\" id=\"deviceData-E\"><path d=\"M6.8 10.8V9.7H1.7V5.9H6V4.8H1.7V1.3h5V.2H.2v10.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/deviceData-E.svg
// module id = YdCB
// module chunks = 6